import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import SharedService from "../services/sharedService";
import apiService from "../services/apiService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (email && password) {
      try {
        const response = await apiService.postData("admin/login", {
          email,
          password,
        });

        if (response?.data?.token) {
          SharedService.setLoginDetails(response);
          localStorage.setItem("token", response.data.token);
          toast.success("Login successful!", {
            position: "top-right",
            autoClose: 2000,
          });

          setTimeout(() => {
            navigate("/user-list");
          }, 2000);
        } else {
          toast.error("Invalid credentials.", {
            position: "top-right",
            autoClose: 3000,
          });
        }
      } catch (error) {
        toast.error("Login failed. Please try again.", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } else {
      toast.warn("Please enter both email and password.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-center vh-100 flex-column">
      <ToastContainer />

      <div className="text-center">
        <img src="assets/img/logo.png" alt="logo" width="250" />
      </div>

      <div className="card card-primary shadow-lg" style={{ width: "400px" }}>
        <div className="card-header">
          <h6>Login</h6>
        </div>
        <div className="card-body">
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter email"
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
            />
          </div>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="form-check">
              {/* <input
                type="checkbox"
                className="form-check-input"
                id="rememberMe"
              />
              <label className="form-check-label" htmlFor="rememberMe">
                Remember Me
              </label> */}
            </div>
            <Link to="/forgot-password" className="text-primary">
              Forgot Password?
            </Link>
          </div>
          <button className="btn btn-primary w-100" onClick={handleLogin}>
            Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
